import type { OrchestrationPhase } from "@calcplan/ai-capabilities";

export const PHASE_FALLBACK_PROGRESS: Record<OrchestrationPhase, readonly string[]> = {
  direct: [
    "Pensando…",
    "Preparando a resposta…",
    "Concluindo o pedido…",
  ],
  discovery: [
    "Analisando o ambiente e o pedido…",
    "Observando o projeto…",
    "Reunindo informações para o plano…",
  ],
  planning: [
    "Planejando as etapas…",
    "Organizando o plano de trabalho…",
    "Preparando o plano para execução…",
  ],
  execution: [
    "Executando o plano…",
    "Trabalhando na etapa atual…",
    "Aplicando as alterações planejadas…",
  ],
  verification: [
    "Conferindo o resultado…",
    "Validando as alterações…",
    "Finalizando a conferência…",
  ],
};

export function phaseFallbackProgress(phase: OrchestrationPhase, index: number): string {
  const labels = PHASE_FALLBACK_PROGRESS[phase];
  return labels[Math.abs(index) % labels.length]!;
}

export function stablePendingProgress(
  previous: string | undefined,
  candidate: string | undefined,
): string | undefined {
  return candidate?.trim() ? candidate : previous;
}
